<template>
  <div>
    <el-card class="box-card">
      <div style="text-align:center;">
        <h4>测评完成</h4>
        <i class="el-icon-circle-check" style="margin:10px 0 10px;font-size:60px;color:#FE8087;"></i>
        <p>测评项目：{{ parseQuestNameByCode(quest.questCode) }}</p>
        <p>完成时间：{{ quest.time }}</p>
      </div>
    </el-card>

    <br>
    <el-button type="primary" round style="width: 100%" @click="buildReport"
               v-loading.fullscreen.lock="fullscreenLoading">查看报告
    </el-button>
  </div>
</template>

<script>
import {mapState} from "vuex";
import HttpRequest from "@/utils/request";
import {formatTimeToStr} from "@/utils/date.js";
import {parseQuestNameByCode} from "@/assets/js/questIntro";

export default {
  components: {},
  data() {
    return {
      quest: {},
      fullscreenLoading: false,
      //
      formatTimeToStr,
      parseQuestNameByCode
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    this.quest = JSON.parse(this.$route.query.data)
  },
  mounted() {
    document.title = '测评成功'
  },
  methods: {
    // getQuest() {
    //   let url = "/constub/getQuest";
    //   let data = {token: this.student.token, questId: this.questId};
    //   HttpRequest.requestFormPost(url, data).then(res => {
    //     if (res && res.result.success) {
    //       this.quest = res.data;
    //     } else {
    //       this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
    //     }
    //   });
    // },
    buildReport() {
      this.fullscreenLoading = true;
      //
      let url = "/constub/buildReport";
      let data = {token: this.student.token, questId: this.quest.questId};
      HttpRequest.requestFormPost(url, data).then(res => {
        this.fullscreenLoading = false;
        if (res && res.result.success) {
          let pdfUrl = res.data;
          // 在延迟后打开新标签页 解决Safari浏览器不支持的问题
          setTimeout(function() {
            window.open(pdfUrl, '_blank');
          }, 1); // 设置延迟时间为1毫秒
        } else {
          this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
        }
      });
    },
  },
};
</script>


<style scoped>
</style>
